<template>
  <div class="app-stack">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppStack',
}
</script>

<style lang="scss" scoped>
.app-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
